import { LOCALES } from 'i18n/locales';

export const workpackFormIntl = {
    [LOCALES.ENGLISH]: {
        'workpackForm.details.title': 'Details',
        'workpackForm.name.label': 'Title',
        'workpackForm.name.description': 'Choose a title for the PDF',
        'workpackForm.name.validation.required': 'Enter a name for this PDF',
        'workpackForm.name.validation.length': 'PDF name must be 255 characters or less',
        'workpackForm.description.label': 'Description',
        'workpackForm.description.description': 'Enter a description for this PDF (optional)',
        'workpackForm.description.validation.length': 'Description must be 255 characters or less',
        'workpackForm.geometry.required': 'Please select an area on the map',
        'workpackForm.scaling.title': 'Scaling',
        'workpackForm.scaling.description': 'Select a map scale and a paper size to create a landscape PDF.',
        'workpackForm.exportOptions.loading': 'Loading paper size and scale options...',
        'workpackForm.mapPreview.edit': 'Edit area',
        'workpackForm.electricityOptIn.title': 'Electricity: Voltage colour coding',
        'workpackForm.electricityOptIn.description': 'Apply voltage colour coding to electricity site maps (excludes the combined map).',
        'workpackForm.electricityOptIn.legend.title': 'Legend',
        'workpackForm.electricityOptIn.option.default': 'Default colours',
        'workpackForm.electricityOptIn.option.default.alt': 'Preview of the default electricity colours option',
        'workpackForm.electricityOptIn.option.colourCoding': 'Voltage specific colours',
        'workpackForm.electricityOptIn.option.colourCoding.alt': 'Preview of the voltage specific electricity colours option',
        'workpackForm.electricityOptIn.legend.all': 'All voltages',
        'workpackForm.electricityOptIn.legend.lv': 'LV or up to 460 Volts',
        'workpackForm.electricityOptIn.legend.6.6kv': '6.6kV',
        'workpackForm.electricityOptIn.legend.11kv': '11kV',
        'workpackForm.electricityOptIn.legend.33kv': '33kV',
        'workpackForm.electricityOptIn.legend.132to400kv': '132 to 400kV',
        'workpackForm.electricityOptIn.legend.other': 'Other or unknown voltage',
        'workpackForm.submitButton.label': 'Create PDF'
    },
    [LOCALES.WELSH]: {
        'workpackForm.details.title': '[Details]',
        'workpackForm.name.label': '[Title]',
        'workpackForm.name.description': '[Choose a title for the PDF]',
        'workpackForm.name.validation.required': '[Enter a name for this PDF]',
        'workpackForm.name.validation.length': '[PDF name must be 255 characters or less]',
        'workpackForm.description.label': '[Description]',
        'workpackForm.description.description': '[Enter a description for this PDF (optional)]',
        'workpackForm.description.validation.length': '[Description must be 255 characters or less]',
        'workpackForm.geometry.required': '[Please select an area on the map]',
        'workpackForm.scaling.title': '[Scaling]',
        'workpackForm.scaling.description': '[Select a map scale and a paper size to create a landscape PDF.]',
        'workpackForm.exportOptions.loading': '[Loading paper size and scale options...]',
        'workpackForm.mapPreview.edit': '[Edit area]',
        'workpackForm.electricityOptIn.title': '[Electricity: Voltage colour coding]',
        'workpackForm.electricityOptIn.description': '[Apply voltage colour coding to electricity site maps (excludes the combined map).]',
        'workpackForm.electricityOptIn.legend.title': '[Legend]',
        'workpackForm.electricityOptIn.option.default': '[Default colours]',
        'workpackForm.electricityOptIn.option.default.alt': '[Preview of the default electricity colours option]',
        'workpackForm.electricityOptIn.option.colourCoding': '[Voltage specific colours]',
        'workpackForm.electricityOptIn.option.colourCoding.alt': '[Preview of the voltage specific electricity colours option]',
        'workpackForm.electricityOptIn.legend.all': '[All voltages]',
        'workpackForm.electricityOptIn.legend.lv': '[LV or up to 460 Volts]',
        'workpackForm.electricityOptIn.legend.6.6kv': '[6.6kV]',
        'workpackForm.electricityOptIn.legend.11kv': '[11kV]',
        'workpackForm.electricityOptIn.legend.33kv': '[33kV]',
        'workpackForm.electricityOptIn.legend.132to400kv': '[132 to 400kV]',
        'workpackForm.electricityOptIn.legend.other': '[Other or unknown voltage]',
        'workpackForm.submitButton.label': '[Create PDF]'
    }
};
